import React, { useState } from 'react';
import './Quizzes.css';

function Quizzes() {
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [score, setScore] = useState(0);
    const [showScore, setShowScore] = useState(false);
    const [selectedAnswer, setSelectedAnswer] = useState(null);

    const quizzes = {
        navaVidhaBhakti: {
            title: "Nava Vidha Bhakti Quiz",
            icon: "🙏",
            color: "#e3f2fd",
            questions: [
                {
                    question: "What does 'Sravanam' mean in the nine processes of devotional service?",
                    options: ["Chanting", "Hearing", "Remembering", "Worshiping"],
                    correct: 1
                },
                {
                    question: "Who is the perfect example of achieving perfection through Sravanam?",
                    options: ["Hanuman", "Maharaja Parikshit", "Arjuna", "Prahlada"],
                    correct: 1
                },
                {
                    question: "Which process of bhakti involves chanting the Lord's glories?",
                    options: ["Smaranam", "Kirtanam", "Vandanam", "Archanam"],
                    correct: 1
                },
                {
                    question: "What is the Sanskrit term for 'Remembering the Lord'?",
                    options: ["Smaranam", "Sravanam", "Dasyam", "Sakhyam"],
                    correct: 0
                },
                {
                    question: "Who exemplified perfection through Pada-sevanam (serving the Lord's feet)?",
                    options: ["Prahlada", "Goddess Lakshmi", "Bali Maharaja", "Akrura"],
                    correct: 1
                },
                {
                    question: "Which process involves deity worship?",
                    options: ["Kirtanam", "Vandanam", "Archanam", "Sakhyam"],
                    correct: 2
                },
                {
                    question: "Hanuman is the perfect example of which process?",
                    options: ["Dasyam (Servitorship)", "Sakhyam (Friendship)", "Sravanam (Hearing)", "Vandanam (Prayers)"],
                    correct: 0
                },
                {
                    question: "Which devotee demonstrated Sakhyam (friendship) with Krishna?",
                    options: ["Prahlada", "Arjuna", "Hanuman", "Parikshit"],
                    correct: 1
                },
                {
                    question: "What is 'Atma-nivedanam'?",
                    options: ["Deity worship", "Complete self-surrender", "Chanting", "Hearing"],
                    correct: 1
                },
                {
                    question: "Where is the verse describing the nine processes found?",
                    options: ["Bhagavad Gita 9.30", "Srimad Bhagavatam 7.5.23", "Brahma Samhita 5.37", "Nectar of Instruction 1"],
                    correct: 1
                }
            ]
        },
        vaishnavaAparadh: {
            title: "Avoiding Vaisnava Aparadh Quiz",
            icon: "⚠️",
            color: "#fff3e0",
            questions: [
                {
                    question: "What is Vaisnava Aparadh?",
                    options: ["Chanting loudly", "Offending devotees of the Lord", "Eating prasadam", "Visiting temples"],
                    correct: 1
                },
                {
                    question: "What is considered the greatest offense in spiritual life?",
                    options: ["Missing temple programs", "Offending a Vaisnava", "Eating before offering", "Sleeping late"],
                    correct: 1
                },
                {
                    question: "How should we view other devotees?",
                    options: ["As ordinary people", "As servants of Krishna", "As competitors", "As beginners"],
                    correct: 1
                },
                {
                    question: "What should we do if we accidentally offend a Vaisnava?",
                    options: ["Ignore it", "Immediately beg forgiveness", "Wait for them to forget", "Justify our actions"],
                    correct: 1
                },
                {
                    question: "Why is Vaisnava Aparadh so serious?",
                    options: ["It stops spiritual progress", "It's not that serious", "It only affects material life", "It can be easily corrected"],
                    correct: 0
                },
                {
                    question: "What attitude should we have towards senior devotees?",
                    options: ["Critical", "Respectful and humble", "Envious", "Indifferent"],
                    correct: 1
                },
                {
                    question: "Is criticizing a devotee's service considered an offense?",
                    options: ["No, it's helping them", "Only if done publicly", "Yes, always", "Only for advanced devotees"],
                    correct: 2
                },
                {
                    question: "What is the result of Vaisnava Aparadh?",
                    options: ["Faster advancement", "Material opulence", "Spiritual impediment", "Better health"],
                    correct: 2
                },
                {
                    question: "How can we avoid Vaisnava Aparadh?",
                    options: ["By being careful in speech and thought", "By avoiding all devotees", "By not going to temple", "By chanting more rounds"],
                    correct: 0
                },
                {
                    question: "Who is most qualified to judge another devotee?",
                    options: ["Anyone", "Senior devotees only", "No one but Krishna", "Temple authorities"],
                    correct: 2
                }
            ]
        },
        faithMaturity: {
            title: "Steps in Maturing of Faith Quiz",
            icon: "🌱",
            color: "#f3e5f5",
            questions: [
                {
                    question: "What is the first step in developing Krishna consciousness?",
                    options: ["Nishtha", "Adau Shraddha", "Bhava", "Prema"],
                    correct: 1
                },
                {
                    question: "What does 'Adau Shraddha' mean?",
                    options: ["Complete surrender", "Initial faith", "Steady practice", "Pure love"],
                    correct: 1
                },
                {
                    question: "What comes after initial faith (Shraddha)?",
                    options: ["Prema", "Sadhu Sanga", "Bhava", "Nishtha"],
                    correct: 1
                },
                {
                    question: "What is 'Bhajana Kriya'?",
                    options: ["Reading books", "Beginning devotional practices", "Temple construction", "Cooking prasadam"],
                    correct: 1
                },
                {
                    question: "What is 'Anartha Nivritti'?",
                    options: ["Chanting 64 rounds", "Cleansing of unwanted habits", "Building temples", "Preaching"],
                    correct: 1
                },
                {
                    question: "What does 'Nishtha' represent?",
                    options: ["Doubt", "Firm steadiness", "Initial interest", "Material attachment"],
                    correct: 1
                },
                {
                    question: "What is 'Ruci'?",
                    options: ["Boredom", "Taste for devotional service", "Material enjoyment", "Sleep"],
                    correct: 1
                },
                {
                    question: "What stage comes before 'Bhava'?",
                    options: ["Prema", "Asakti", "Shraddha", "Sadhu Sanga"],
                    correct: 1
                },
                {
                    question: "What is the final stage of spiritual perfection?",
                    options: ["Nishtha", "Ruci", "Prema", "Asakti"],
                    correct: 2
                },
                {
                    question: "How many stages are there from Shraddha to Prema?",
                    options: ["5", "7", "9", "11"],
                    correct: 2
                }
            ]
        }
    };

    const handleAnswerClick = (selectedIndex) => {
        setSelectedAnswer(selectedIndex);
        const quiz = quizzes[selectedQuiz];

        if (selectedIndex === quiz.questions[currentQuestion].correct) {
            setScore(score + 1);
        }

        setTimeout(() => {
            const nextQuestion = currentQuestion + 1;
            if (nextQuestion < quiz.questions.length) {
                setCurrentQuestion(nextQuestion);
                setSelectedAnswer(null);
            } else {
                setShowScore(true);
            }
        }, 1000);
    };

    const resetQuiz = () => {
        setSelectedQuiz(null);
        setCurrentQuestion(0);
        setScore(0);
        setShowScore(false);
        setSelectedAnswer(null);
    };

    const restartQuiz = () => {
        setCurrentQuestion(0);
        setScore(0);
        setShowScore(false);
        setSelectedAnswer(null);
    };

    if (!selectedQuiz) {
        return (
            <div className="quizzes-page">
                <h1 className="page-title">📝 Test Your Knowledge 📝</h1>

                <div className="quiz-intro">
                    <p>
                        Challenge yourself with our spiritual knowledge quizzes! Each quiz contains
                        10 questions to test your understanding of ISKCON philosophy and devotional practices.
                    </p>
                </div>

                <div className="quiz-selection">
                    <div className="quiz-card" onClick={() => setSelectedQuiz('navaVidhaBhakti')}>
                        <div className="quiz-icon">🙏</div>
                        <h2>Nava Vidha Bhakti</h2>
                        <p>Test your knowledge of the nine processes of devotional service</p>
                        <button className="start-quiz-btn">Start Quiz</button>
                    </div>

                    <div className="quiz-card" onClick={() => setSelectedQuiz('vaishnavaAparadh')}>
                        <div className="quiz-icon">⚠️</div>
                        <h2>Avoiding Vaisnava Aparadh</h2>
                        <p>Learn about offenses to devotees and how to avoid them</p>
                        <button className="start-quiz-btn">Start Quiz</button>
                    </div>

                    <div className="quiz-card" onClick={() => setSelectedQuiz('faithMaturity')}>
                        <div className="quiz-icon">🌱</div>
                        <h2>Steps in Maturing of Faith</h2>
                        <p>Understand the progressive stages from Shraddha to Prema</p>
                        <button className="start-quiz-btn">Start Quiz</button>
                    </div>
                </div>
            </div>
        );
    }

    const quiz = quizzes[selectedQuiz];

    if (showScore) {
        const percentage = (score / quiz.questions.length) * 100;
        let message = "";
        let emoji = "";

        if (percentage === 100) {
            message = "Perfect! You have excellent knowledge!";
            emoji = "🏆";
        } else if (percentage >= 80) {
            message = "Great job! You know your philosophy well!";
            emoji = "⭐";
        } else if (percentage >= 60) {
            message = "Good effort! Keep studying!";
            emoji = "👍";
        } else {
            message = "Keep learning! Study more about ISKCON philosophy.";
            emoji = "📚";
        }

        return (
            <div className="quiz-results">
                <div className="results-card">
                    <div className="results-emoji">{emoji}</div>
                    <h1>Quiz Complete!</h1>
                    <div className="score-display">
                        <div className="score-number">{score}</div>
                        <div className="score-total">out of {quiz.questions.length}</div>
                    </div>
                    <div className="percentage">{percentage.toFixed(0)}%</div>
                    <p className="result-message">{message}</p>
                    <div className="result-buttons">
                        <button className="btn-primary" onClick={restartQuiz}>Retry Quiz</button>
                        <button className="btn-secondary" onClick={resetQuiz}>Choose Another Quiz</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="quiz-active">
            <div className="quiz-header">
                <button className="back-btn" onClick={resetQuiz}>← Back to Quizzes</button>
                <h2>{quiz.title}</h2>
                <div className="quiz-progress">
                    Question {currentQuestion + 1} of {quiz.questions.length}
                </div>
            </div>

            <div className="question-card">
                <div className="question-number">Question {currentQuestion + 1}</div>
                <h3 className="question-text">{quiz.questions[currentQuestion].question}</h3>

                <div className="answers-grid">
                    {quiz.questions[currentQuestion].options.map((option, index) => {
                        let buttonClass = "answer-btn";
                        if (selectedAnswer !== null) {
                            if (index === quiz.questions[currentQuestion].correct) {
                                buttonClass += " correct";
                            } else if (index === selectedAnswer) {
                                buttonClass += " incorrect";
                            }
                        }

                        return (
                            <button
                                key={index}
                                className={buttonClass}
                                onClick={() => handleAnswerClick(index)}
                                disabled={selectedAnswer !== null}
                            >
                                {option}
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="quiz-footer">
                <div className="score-tracker">
                    Current Score: {score} / {currentQuestion + (selectedAnswer !== null ? 1 : 0)}
                </div>
            </div>
        </div>
    );
}

export default Quizzes;
